"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyleIconButton = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5)
    }
  };
});
var ClosabeTabLabel = function ClosabeTabLabel(props) {
  var title = props.title,
    handleClose = props.handleClose,
    index = props.index,
    _props$small = props.small,
    small = _props$small === void 0 ? false : _props$small,
    preCloseTab = props.preCloseTab;
  var classes = useStyleIconButton();
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    onClick: function onClick(event) {
      event.stopPropagation();
      preCloseTab(title, index, handleClose);
    }
  }, /*#__PURE__*/_react["default"].createElement(_HighlightOff["default"], {
    className: "".concat(small ? classes.icon : '')
  }));
};
var _default = ClosabeTabLabel;
exports["default"] = _default;